import styled from "styled-components";

/**
 * Wrapper Principal do StopsFilter
 * Configura o layout do filtro de paradas.
 */
export const StopsFilterWrapper = styled.div`
  gap: ${({ theme }) => theme.spacing(2)};
  flex-direction: column;
  display: flex;
`;

/**
 * Wrapper do Cabeçalho
 * Inclui o ícone e o título estilizado.
 */
export const StyledHeaderWrapper = styled.div`
  gap: ${({ theme }) => theme.spacing(2)};
  display: flex;
  align-items: center;

  & > p {
    padding-bottom: ${({ theme }) => theme.spacing(1)};
  }

  & > svg > path {
    fill: ${({ theme }) => theme.colors.black};
    stroke-width: 2;
  }
`;
